import { Button } from "plos/src/components/buttons/Button";
import { UseFormHandleSubmit, UseFormWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useOnboardingContext } from "../../../../contexts/OnboardingContext";
import { EntryDetailsFormData } from "../types";

interface OnboardingButtonsProps {
  handleSubmit: UseFormHandleSubmit<EntryDetailsFormData, EntryDetailsFormData>;
  watch: UseFormWatch<EntryDetailsFormData>;
}

const OnboardingButtons = ({ handleSubmit, watch }: OnboardingButtonsProps) => {
  const { t } = useTranslation("onboarding");
  const {
    activeSurface,
    isTutorialEnabled,
    setEntryDetails,
    goToAutopickChoice,
    autopickChoice,
    setAutopickChoice,
    goToWizard,
    handleClose,
    submitEntry,
  } = useOnboardingContext();

  const {
    name,
    favourite_team: favouriteTeam,
    terms_agreed: termsAgreed,
  } = watch();

  const canContinue =
    Boolean(name?.trim()) && favouriteTeam != null && Boolean(termsAgreed);

  const onSubmit = (values: EntryDetailsFormData) => {
    setEntryDetails(values);

    if (!isTutorialEnabled) {
      setAutopickChoice("manual_pick");
      handleClose();
      return;
    }

    goToAutopickChoice();
  };

  const handleContinue = () => {
    setAutopickChoice(autopickChoice);
    if (autopickChoice === "show_tutorial") {
      goToWizard();
    } else {
      // Manual pick: close the survey so the user can build their squad on the
      // squad page, then submit via the Enter Squad button.
      handleClose();
    }
  };

  const entryDetailsButtonText = isTutorialEnabled
    ? t("continue", "Continue")
    : t("pickTeam", "Pick Team");

  const autoPickChoiceButtonText =
    autopickChoice === "manual_pick"
      ? t("pickTeam", "Pick Team")
      : t("continue", "Continue");

  switch (activeSurface) {
    case "entryDetails":
      return (
        <Button
          fullWidth
          isDisabled={!canContinue}
          onPress={() => handleSubmit(onSubmit)()}
        >
          {entryDetailsButtonText}
        </Button>
      );
    case "autopickChoice":
      return (
        <Button fullWidth onPress={handleContinue}>
          {autoPickChoiceButtonText}
        </Button>
      );
    case "wizard":
      return (
        <Button fullWidth onPress={submitEntry}>
          {t("generateTeam", "Generate Team")}
        </Button>
      );
    default:
      return null;
  }
};

export default OnboardingButtons;
